import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignupsDisplay.css';

export default function SignupsDisplay() {
  const API = process.env.REACT_APP_API_URL;
  const [fencers, setFencers] = useState([]);
  const [activeCompetitions, setActiveCompetitions] = useState([]);
  const [selectedCompIndex, setSelectedCompIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.backgroundColor = '#000';
  
    const container = scrollRef.current;
    if (!container) {
      console.warn('Scroll container not found');
      return;
    }
  
    container.scrollTop = 0;
  
    let direction = 1;
    const speed = 1;
  
    const interval = setInterval(() => {
      const maxScroll = container.scrollHeight - container.clientHeight;
      container.scrollTop += speed * direction;
  
      if (container.scrollTop >= maxScroll || container.scrollTop <= 0) {
        direction *= -1;
      }
    }, 30);
  
    return () => clearInterval(interval);
  }, [fencers]);
  

  useEffect(() => {
  let intervalId;

  async function fetchFencersInActiveComps() {
    try {
      const competitionsRes = await fetch(`${API}/competitions?active=true`);
      const competitions = await competitionsRes.json();
      setActiveCompetitions(competitions);

      const allFencerPromises = competitions.map(async (comp) => {
        const res = await fetch(`${API}/competitions/${comp.id}/fencers`);
        const compFencers = await res.json();
        return compFencers.map(f => ({ ...f, competitionName: comp.name }));
      });

      const fencerLists = await Promise.all(allFencerPromises);
      setFencers(fencerLists.flat());
    } catch (error) {
      console.error('Failed to fetch fencers:', error);
    } finally {
      setLoading(false);
    }
  }

  fetchFencersInActiveComps();
  intervalId = setInterval(fetchFencersInActiveComps, 30000);

  return () => clearInterval(intervalId);
}, []);


  if (loading) return <p>Loading Competitions...</p>;
  if (activeCompetitions.length === 0) return <p>No active competitions.</p>;

  const selectedCompetition = activeCompetitions[selectedCompIndex];
  const selectedFencers = fencers.filter(f => f.competitionName === selectedCompetition.name);

  return (
    <div className='signups-display'>
      <div>
        <button onClick={()=> {navigate('/')}}>Back</button>
        {activeCompetitions.map((comp, i) => (
          <button
            key={comp.id}
            onClick={() => setSelectedCompIndex(i)}
            type="button"
          >
            {comp.name}
          </button>
        ))}
      </div>
      <h2>{selectedCompetition.name}</h2>
      <div className='fencer-scroll-container' ref={scrollRef}>
        {selectedFencers.length === 0 ? (
          <p>📝 No fencers signed up yet. Sign up is open!</p>
        ) : (
          <div className='fencer-item'>
            {selectedFencers.map(f => (
              <span key={f.id}> {f.name}: {f.club || '—'} </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
